import type ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import IdentityProvidersConnection from 'workspaces/launcher/connections/IdentityProvidersConnection';
import IdentityProvidersConstants from 'workspaces/launcher/constants/IdentityProvidersConstants';
import IdentityProviders from 'workspaces/launcher/data/IdentityProviders';

function handleFetchSuccess (item: IdentityProviders) {
  AppDispatcher.dispatch({
    actionType: IdentityProvidersConstants.GET_SUCCESS,
    item: item,
    logLevel: 'trace'
  });
}

function handleFetchFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: IdentityProvidersConstants.GET_FAILURE,
    error: error,
    logLevel: 'trace'
  });
}

function fetch () {
  IdentityProvidersConnection.fetch(handleFetchSuccess, handleFetchFailure);
}

function handleSaveSuccess (item: IdentityProviders) {
  AppDispatcher.dispatch({
    actionType: IdentityProvidersConstants.SAVE_SUCCESS,
    item: item,
    logLevel: 'trace'
  });
}

function handleSaveFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: IdentityProvidersConstants.SAVE_FAILURE,
    error: error,
    logLevel: 'trace'
  });
}

function save (item: IdentityProviders) {
  let _item = item
    .set('ldapConfig', item.ldapConfig
      .set('password', '')
      .set('isPasswordEdited', false)
  );

  AppDispatcher.dispatch({
    actionType: IdentityProvidersConstants.SAVE,
    item: _item,
    logLevel: 'trace'
  });

  IdentityProvidersConnection.save(item, handleSaveSuccess, handleSaveFailure);
}

const IdentityProvidersActions = {
  fetch,
  save
};

export default IdentityProvidersActions;
